const setCustomerBalancesDetailsData=(state,data)=>{

    state.customerBalancesDetailsData = data
  
  }

  export default {
    setCustomerBalancesDetailsData
  }